import { useTranslation } from '@/src/i18n';
import { Button, Input } from '@/src/presentation/components';
import { Image, KeyboardAvoidingView, Platform, Text, TouchableOpacity, View } from 'react-native';
import { createStyles } from './ForgotPasswordScreen.styles';

export interface ForgotPasswordScreenProps {
  email: string;
  setEmail: (value: string) => void;
  loading: boolean;
  handleResetPassword: () => void;
  navigateBack: () => void;
  colors: {
    background: string;
    text: string;
    textSecondary: string;
    textTertiary: string;
    card: string;
    border: string;
    primary: string;
    primaryText: string;
    error: string;
  };
}

export const ForgotPasswordScreen = ({
  email,
  setEmail,
  loading,
  handleResetPassword,
  navigateBack,
  colors,
}: ForgotPasswordScreenProps) => {
  const styles = createStyles();
  const { t } = useTranslation();

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={[styles.container, { backgroundColor: colors.background }]}
    >
      <View style={styles.content}>
        <View style={styles.logoContainer}>
          <Image source={require('@/assets/images/android-icon-foreground.png')} style={styles.logoImage} />
        </View>
        <Text style={[styles.title, { color: colors.text }]}>{t('auth.resetPassword')}</Text>
        <Text style={[styles.subtitle, { color: colors.textSecondary }]}>{t('auth.forgotPasswordSubtitle')}</Text>

        <View style={styles.form}>
          <Input
            placeholder={t('auth.email')}
            value={email}
            onChangeText={setEmail}
            autoCapitalize="none"
            keyboardType="email-address"
            editable={!loading}
            colors={colors}
          />

          <Button
            title={t('auth.sendResetLink')}
            onPress={handleResetPassword}
            disabled={loading}
            loading={loading}
            colors={colors}
          />

          <TouchableOpacity style={styles.backButton} onPress={navigateBack}>
            <Text style={[styles.backButtonText, { color: colors.primary }]}>{t('auth.backToLogin')}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </KeyboardAvoidingView>
  );
};
